module.exports = __webpack_public_path__ + "static/media/app_icon.6a648e37.png";